import { render, staticRenderFns } from "./SafeCode.vue?vue&type=template&id=b88b8384&scoped=true&"
import script from "./SafeCode.vue?vue&type=script&lang=js&"
export * from "./SafeCode.vue?vue&type=script&lang=js&"
import style0 from "./SafeCode.vue?vue&type=style&index=0&id=b88b8384&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b88b8384",
  null
  
)

export default component.exports